import { render, staticRenderFns } from "./DriverTicketList.vue?vue&type=template&id=6f8b6e64&scoped=true&"
import script from "./DriverTicketList.vue?vue&type=script&lang=js&"
export * from "./DriverTicketList.vue?vue&type=script&lang=js&"
import style0 from "./DriverTicketList.vue?vue&type=style&index=0&id=6f8b6e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8b6e64",
  null
  
)

export default component.exports